import { forwardRef } from 'react';
import { WeaveTheme } from '@frontend/theme';

export interface PremiumBadgeProps extends React.SVGProps<SVGSVGElement> {
  colors: WeaveTheme['colors'];
  primaryColor?: string;
  secondaryColor?: string;
}

const PremiumBadge = forwardRef<SVGSVGElement, PremiumBadgeProps>(
  ({ colors, primaryColor, secondaryColor, ...props }, ref) => {
    return (
      <svg {...props} ref={ref} fill='none' viewBox='0 0 24 24'>
        <g filter='url(#shadow)'>
          <g clipPath='url(#a)'>
            <mask id='c' width='10' height='13' x='7' y='10' maskUnits='userSpaceOnUse' style={{ maskType: 'alpha' }}>
              <path
                fill={primaryColor ?? colors.secondary.seaweed50}
                d='m7.227 22.66.318-11.773h8.91l.318 11.772L12 20.432z'
              ></path>
            </mask>
            <g mask='url(#c)'>
              <path
                fill={secondaryColor ?? colors.secondary.seaweed40}
                d='m7.227 22.66.318-11.773h8.91l.318 11.772L12 20.432z'
              ></path>
              <path fill='#3EBFB8' d='m15.59 11.773.257 9.477L12 19.455 8.151 21.25l.256-9.477z'></path>
              <g filter='url(#d)' style={{ mixBlendMode: 'overlay' }}>
                <path fill='url(#e)' d='M5.636 12.16h12.727v11.454H5.636z'></path>
              </g>
            </g>
            <path fill={secondaryColor ?? colors.secondary.seaweed40} d='M19 8.34a7 7 0 1 1-14 0 7 7 0 0 1 14 0'></path>
            <path fill='url(#f)' d='M19 8.34a7 7 0 1 1-14 0 7 7 0 0 1 14 0' style={{ mixBlendMode: 'multiply' }}></path>
            <path fill='url(#g)' d='M16.773 8.341a4.773 4.773 0 1 1-9.546 0 4.773 4.773 0 0 1 9.546 0'></path>
            <path
              fill='black'
              fillOpacity='.75'
              fillRule='evenodd'
              d='M11.575 7.863v.927c0 .995.823 1.81 1.858 1.837.979 0 1.795-.72 1.881-1.656.015-.138.02-.492.02-.63 0-.14-.005-.493-.02-.631a1.815 1.815 0 0 0-1.1-1.502 1.947 1.947 0 0 0-1.9.195.047.047 0 0 0 0 .061l.395.63a.04.04 0 0 0 .028.016.04.04 0 0 0 .031-.01 1.07 1.07 0 0 1 1.037-.17c.352.128.604.43.658.788.02.205.03.412.027.618.003.204-.006.409-.027.612-.071.493-.51.86-1.027.86a1.025 1.025 0 0 1-.712-.298.978.978 0 0 1-.293-.698v-.927c0-.997-.827-1.812-1.864-1.836-.98.001-1.797.722-1.881 1.66-.015.138-.02.491-.02.63 0 .14 0 .493.02.63a1.814 1.814 0 0 0 1.101 1.502 1.947 1.947 0 0 0 1.9-.197.047.047 0 0 0 0-.06l-.394-.63a.04.04 0 0 0-.059-.006 1.07 1.07 0 0 1-1.037.17 1.005 1.005 0 0 1-.658-.789 5.362 5.362 0 0 1-.025-.618 5.093 5.093 0 0 1 .025-.612c.072-.492.51-.86 1.027-.86.27.004.526.112.712.299a.978.978 0 0 1 .294.697l.003-.002'
              clipRule='evenodd'
            ></path>
            <path
              fill='url(#h)'
              fillOpacity='.3'
              d='M16.773 8.341a4.773 4.773 0 1 1-9.546 0 4.773 4.773 0 0 1 9.546 0'
            ></path>
          </g>
        </g>
        <defs>
          <radialGradient
            id='f'
            cx='0'
            cy='0'
            r='1'
            gradientTransform='rotate(120.069 3.596 7.63)scale(6.98552)'
            gradientUnits='userSpaceOnUse'
          >
            <stop offset='.737' stopColor='#D9D9D9'></stop>
            <stop offset='.888' stopColor='white'></stop>
            <stop offset='1' stopColor='#E5E5E5'></stop>
          </radialGradient>
          <radialGradient
            id='g'
            cx='0'
            cy='0'
            r='1'
            gradientTransform='rotate(90.002 2.25 9.75)scale(5.61384)'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#DFFFFD'></stop>
            <stop offset='1' stopColor='#4CDCD3'></stop>
          </radialGradient>
          <radialGradient
            id='h'
            cx='0'
            cy='0'
            r='1'
            gradientTransform='rotate(123.024 4.494 6.98)scale(6.32487)'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='white'></stop>
            <stop offset='.466' stopColor='#D9D9D9'></stop>
            <stop offset='1' stopColor='#676767'></stop>
          </radialGradient>

          <filter
            id='d'
            width='21.727'
            height='20.455'
            x='1.136'
            y='7.66'
            colorInterpolationFilters='sRGB'
            filterUnits='userSpaceOnUse'
          >
            <feFlood floodOpacity='0' result='BackgroundImageFix'></feFlood>
            <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape'></feBlend>
            <feTurbulence
              baseFrequency='0.99900001287460327 0.99900001287460327'
              numOctaves='3'
              seed='958'
              type='fractalNoise'
            ></feTurbulence>
            <feDisplacementMap
              width='100%'
              height='100%'
              in='shape'
              result='displacedImage'
              scale='9'
              xChannelSelector='R'
              yChannelSelector='G'
            ></feDisplacementMap>
            <feMerge result='effect1_texture_2982_16213'>
              <feMergeNode in='displacedImage'></feMergeNode>
            </feMerge>
          </filter>
          <linearGradient id='e' x1='11.999' x2='11.999' y1='12.16' y2='23.615' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#EEEEEE'></stop>
            <stop offset='1' stopColor='#5C5C5C'></stop>
          </linearGradient>
          <clipPath id='a'>
            <path fill='white' d='M0 0h24v24H0z'></path>
          </clipPath>
          <filter id='shadow' x='-20%' y='-20%' width='140%' height='140%' colorInterpolationFilters='sRGB'>
            <feDropShadow
              dx='0'
              dy='1'
              stdDeviation='1.5'
              floodColor='rgb(30,50,81)'
              floodOpacity='0.15'
            ></feDropShadow>
          </filter>
        </defs>
      </svg>
    );
  }
);

PremiumBadge.displayName = 'PremiumBadge';

export default PremiumBadge;
